module.exports = __webpack_public_path__ + "static/media/close.713e19f7.svg";